import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchTransferWorkOrderList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/transferWorkOrder/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchTransferWorkOrderList', payload)
            } else {
                commit('setTransferWorkOrderList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchTransferWorkOrderData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/transferWorkOrder/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.list_deploy) {
                commit('setTransferWorkOrderList_ItemList', {item_list: res.data.response.item_list, id: payload.id})
            } else {
                commit('setTransferWorkOrderData', {response: res.data.response, copy: payload.copy})   
            }
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetTransferWorkOrderData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitTransferWorkOrderData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
//    return
    axios.post('/transferWorkOrder/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            dispatch('fetchTransferWorkOrderData', {id: res.data.id})                    
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
        dispatch('fetchTransferWorkOrderData', {id: payload.id})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteTransferWorkOrderData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/transferWorkOrder/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchTransferWorkOrderList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadReadyItemsForTransfer = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/transferWorkOrder/loadReadyItemsForTransfer.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setLoadReadyItemsForTransfer', res.data.response)
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/transferWorkOrder/actions.js